import React, { Component } from "react";
import { Link } from "react-router-dom";
import parse from "html-react-parser";

class ServiceV4 extends Component {
  render() {
    return (
      <section className="service-five  go-top">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <div className="service-five__single">
                <div className="service-five__single-inner">
                  <div className="service-five__icon">
                    <i className="far fa-chart-line" />
                  </div>
                  {/* /.service-five__icon */}
                  <h3>
                    <Link to="/service-details">
                      Our Commitment to Client Success
                    </Link>
                  </h3>
                  <p>
                    Client success is our priority. Trust, transparency,
                    measurable results. Dedicated team for exceptional service
                    and exceeding expectations.{" "}
                  </p>
                </div>
                {/* /.service-five__single-inner */}
              </div>
              {/* /.service-five__single */}
            </div>
            {/* /.col-lg-4 */}
            <div className="col-lg-4">
              <div className="service-five__single">
                <div className="service-five__single-inner">
                  <div className="service-five__icon">
                    <i className="far fa-rss" />
                  </div>
                  {/* /.service-five__icon */}
                  <h3>
                    <Link to="/service-details">
                      Our Core Values and Philosophy
                    </Link>
                  </h3>
                  <p>
                    Passion, integrity, transparency. Continuous learning,
                    innovative techniques. Client success is our driving force,
                    exceeding expectations at every step.
                  </p>
                </div>
                {/* /.service-five__single-inner */}
              </div>
              {/* /.service-five__single */}
            </div>
            {/* /.col-lg-4 */}
            <div className="col-lg-4">
              <div className="service-five__single">
                <div className="service-five__single-inner">
                  <div className="service-five__icon">
                    <i className="far fa-unlock-alt" />
                  </div>
                  {/* /.service-five__icon */}
                  <h3>
                    <Link to="/service-details">Our Team of Experts </Link>
                  </h3>
                  <p>
                    Experienced experts delivering results. Diverse backgrounds,
                    up-to-date knowledge, commitment to outstanding outcomes.
                    Your success is our priority.
                  </p>
                </div>
                {/* /.service-five__single-inner */}
              </div>
              {/* /.service-five__single */}
            </div>
            {/* /.col-lg-4 */}
          </div>
          {/* /.row */}
        </div>
        {/* /.container */}
      </section>
    );
  }
}

export default ServiceV4;
